import { throttle } from 'lodash';

export default (func, wait = 500, leading = true, trailing = true) =>
  throttle(func, wait, {
    leading,
    trailing,
  });



// WEBPACK FOOTER //
// ./src/utils/throttle.js